<template lang="pug">
  ul.poll-question
    li(v-for="(answer, aIdx) in answers" :key="aIdx")
      input(
        type="radio"
        :id="answerID + aIdx"
        :value="answer.value"
        v-model="questionModel"
      )
      label(
        :for="answerID + aIdx"
        v-text="answer.text"
      )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PollQuestion',
  // Props ---------------------------------------------------------------------
  props: {
    // Question ID
    id: {
      type: Number,
      default: 0
    },
    // Index
    idx: {
      type: Number,
      default: 0
    },
    // Answers
    answers: {
      type: Array,
      default () {
        return []
      }
    },
    // Total
    total: {
      type: Number,
      default: 0
    }
  },
  // Watch ---------------------------------------------------------------------
  watch: {
    // Question model watcher
    questionModel: {
      handler (v) {
        this.SET_NAV_FIELD({ f: 'disableNext', v: !v }) // disabled status of the next btn
      },
      immediate: true
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the user SM
    ...mapGetters('moduleUser', ['getPollAnswers']),
    // Answer ID
    answerID () {
      return `answer-${this.id}-`
    },
    // Question model
    questionModel: {
      get () { return this.getPollAnswers[this.idx] },
      set (v) { this.SET_POLL_ANSWER({ idx: this.idx, v }) }
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map actions of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_NAV_FIELD'
    ]),
    // Vuex map actions of the User SM
    ...mapMutations('moduleUser', [
      'SET_POLL_ANSWER'
    ])
  }
}
</script>
